<div #mainBox [class.top-box]="isTopBox" [class.bottom-box]="isBottomBox" class="duration-box pointer"
	(clickOutside)="onClickOutside()" [additionalElementRefs]="extraBoxes">
	<div class="flag flex-column no-select"
		(mousedown)="startLongPress()" (mouseup)="endLongPress($event)" (mouseleave)="endLongPress($event)"
		(touchstart)="startLongPress()" (touchend)="endLongPress($event)" (touchcancel)="endLongPress($event)">

		<div class="duration-container">
			<div class="flag-text">{{ text }}
				<span class="sd-text">{{target?.DiscriminativeStimulus}}</span>
			</div>
			<div class="badge-count ng-star-inserted" style="font-size: 22px; font-weight: 700;" [ngStyle]="{ color: currentBalance >= 0 ? '#2ecc71' : '#e74c3c' }">
				{{ formatCurrency(currentBalance) }}
			</div>
			<div class="duration-controls">
				<button class="update-currency-button ng-star-inserted" type="button" (click)="openCalculator()">Update</button>
			</div>
		</div>

		<button class="badge-bottom-left" (click)="openDetails($event)">?</button>
	</div>
</div>

@if (detailsOpened) {
<app-target-details [target]="target" (onCloseDetails)="onCloseDetails()" [isPreview]="isPreview"></app-target-details>
}

<!-- History (long press) -->
<div class="extra-container" #extraBox [class.hide]="!extraOpened">
	<div class="extra-close" (click)="closeExtra()">X</div>
	<div class="extra-container-textbox">
		<div *ngFor="let t of transactions; let i = index" class="extra-text">
			<div>{{ t.FormattedDate }}</div>
			<div>{{ (t.Delta>0?'+':'') + t.Delta }} ({{ formatCurrency(balanceAtIndex(i)) }})</div>
		</div>
	</div>
</div>

<!-- Calculator -->
<div class="extra-container currency-calculator-container" #extraBox2 [class.hide]="!extra2Opened">
	<div class="extra-close" (click)="closeExtra2()">X</div>
	<div class="currency-calculator-content">
		<div class="currency-section currency-balance-section">
			<div class="currency-label">Current Balance</div>
			<div class="currency-balance-display" [ngStyle]="{ color: currentBalance >= 0 ? '#2ecc71' : '#e74c3c' }">
				{{ formatCurrency(currentBalance) }}
			</div>
		</div>
		
		<div class="currency-section currency-quick-section">
			<div class="currency-label">Quick Operations</div>
			<div class="currency-buttons-row">
				<button class="currency-quick-btn" type="button" (click)="selectQuick(-5)">-5</button>
				<button class="currency-quick-btn" type="button" (click)="selectQuick(-1)">-1</button>
				<button class="currency-quick-btn" type="button" (click)="selectQuick(1)">+1</button>
				<button class="currency-quick-btn" type="button" (click)="selectQuick(5)">+5</button>
			</div>
		</div>
		
		<div class="currency-section currency-custom-section">
			<div class="currency-label">Custom Amount</div>
			<div class="currency-custom-row">
				<p-inputNumber 
					[showButtons]="false" 
					[(ngModel)]="customAmount"
					styleClass="currency-custom-input">
				</p-inputNumber>
			</div>
		</div>
		
		<div class="currency-info-box">
			<div class="currency-info-line">
				<span class="currency-info-label">Selected Operation:</span>
				<span class="currency-info-value" [ngStyle]="{ color: selectedDelta >= 0 ? '#2ecc71' : '#e74c3c' }">
					{{ (selectedDelta>0?'+':'') + selectedDelta }}
					<span *ngIf="customAmount">, {{ customAmount }}</span>
				</span>
			</div>
			<div class="currency-info-line">
				<span class="currency-info-label">Resulting Balance:</span>
				<span class="currency-result-display" [ngStyle]="{ color: resultingBalance >= 0 ? '#2ecc71' : '#e74c3c' }">
					{{ formatCurrency(resultingBalance) }}
				</span>
			</div>
		</div>
		
		<div class="currency-confirm-row">
			<button class="side-menu-button2 currency-confirm-btn" type="button" (click)="confirmOperation()">Confirm</button>
		</div>
	</div>
</div>

